<mat-card>
    <mat-card-content>
        <p *ngIf="result === true">Odběr obsahu byl zrušen</p>
        <p *ngIf="result === false">Neplatný obsah</p>
        <small>{{'content_id' | translate}}</small>
        <p>{{id}}</p>
    </mat-card-content>
</mat-card>
